import axios from 'axios'
import router from "@/router"

const localStoragePwa = JSON.parse(localStorage.getItem('pwa'))

const state = {
	isAuthenticated: localStoragePwa ? localStoragePwa.isAuthenticated : false,
	technician: null
};

const getters = {
	pwaIsAuthenticated: state => state.isAuthenticated,
	pwaTechnician: state => state.technician
}

const mutations = {
	setIsAuthenticated(state, payload) {
		state.isAuthenticated = payload.pwaAuthenticated
	},
	setTechnician(state, payload) {
		state.technician = payload.pwaTechnician
	}
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {

	pwaLogin(context, payload) {
		return axios.post(`${process.env.VUE_APP_API_PWA_BASE_URL}/login`, payload, options)
			.then((response) => {
				localStorage.setItem('pwa', JSON.stringify({
					isAuthenticated: true,
					access_token: response.data.token,
					offline_all_data: false,
					offline_current_day: false,
					fromLogin: true
				}))
				context.commit("setIsAuthenticated", {
					pwaAuthenticated: true,
				})
				context.commit('setTechnician', {
					pwaTechnician: response.data
				})
				router.push({ name: 'Pwa Dashboard' })
			})
	},

	pwaGetTechnician(context, payload) {
		return axios.post(`${process.env.VUE_APP_API_PWA_BASE_URL}/me`, payload, options)
			.then((response) => {
				context.commit('setTechnician', {
					pwaTechnician: response.data
				})
				
				return response
			})
	},

	pwaLogout(context, payload) {
		return axios.post(`${process.env.VUE_APP_API_PWA_BASE_URL}/logout`, payload, options)
			.then((response) => {
				// clear LocalStorage
				localStorage.removeItem('pwa')
				localStorage.removeItem('pwa-version-reload')
				localStorage.removeItem('pwa-cache-reload')
				
				// clear Vuex data
				context.commit("setIsAuthenticated", {
					pwaAuthenticated: false
				});
				context.commit("setTechnician", {
					pwaTechnician: null
				});
				
				router.push({ name: "pwaLogin" })
			})
	},
}

const pwaAuth = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default pwaAuth;
